import { MAX_FILE_BYTES, CONTENT_PART_BYTES } from './limits.js';
export async function saveOriginal(file, noteId, api, progress = () => {}) {
  if (!file.size || file.size > MAX_FILE_BYTES) throw new Error('原始檔案需介於 1 byte 至 50 MB');
  const bytes = new Uint8Array(await file.arrayBuffer());
  const count = Math.ceil(bytes.length / 750000);
  const upload = await api('file-uploads', { method: 'POST', body: { totalBytes: Math.ceil(bytes.length / 3) * 4, partCount: count } });
  for (let index = 0; index < count; index++) {
    const part = bytes.subarray(index * 750000, (index + 1) * 750000); let raw = '';
    for (let offset = 0; offset < part.length; offset += 8192) raw += String.fromCharCode(...part.subarray(offset, offset + 8192));
    await api('file-uploads/' + upload.id + '/parts/' + index, { method: 'PUT', body: btoa(raw) });
    progress(index + 1, count);
  }
  await api('file-uploads/' + upload.id + '/complete', { method: 'POST', body: {} });
  await api('notes/' + noteId + '/original', { method: 'POST', body: { original_ref: upload.id, name: file.name, originalBytes: file.size } });
}
export async function loadOriginal(note) {
  if (note.original_storage !== 'd1') {
    const response = await fetch('/api/notes/' + note.id + '/original');
    if (!response.ok) throw new Error('無法下載原始檔案');
    return new File([await response.blob()], note.original_name);
  }
  const response = await fetch('/api/notes/' + note.id + '/original/content');
  if (!response.ok) throw new Error('無法取得原始檔案');
  const meta = await response.json(), parts = [];
  for (let index = 0; index < meta.partCount; index++) {
    const part = await fetch(meta.partUrl + index); if (!part.ok) throw new Error('原始檔案分段下載失敗');
    parts.push(Uint8Array.from(atob(await part.text()), character => character.charCodeAt(0)));
  }
  return new File(parts, note.original_name, { type: note.original_type });
}
